export const calculateModules11 = (id) => {
    var to = 10;
    var multiply = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
    var sum = 0;
    var pos = 0;
    var i;
    for (i = 0; i < to; i++) {
        var x = id.substring(pos, pos + 1);
        var intValue = parseInt(x, 10);
        sum += intValue * multiply[i];
        if (i === 5) {
            pos++; //Ignore dash
        }
        pos++;
    }
    return sum;
  }
  export const getFullYear = (id) => {
    var year = parseInt(id.substring(4, 6), 10);
    var digit8 = parseInt(id.substring(7, 8), 10);
    var fullYear = 0;
    switch (digit8) {
        case 0:
        case 1:
        case 2:
        case 3:
            fullYear = 1900 + year;                       
            break;
        case 4:
            if (year < 37) {
                fullYear = 2000 + year;
            }
            else {
                fullYear = 1900 + year;
            }
            break;
        case 5:
        case 6:
        case 7:
        case 8:
            if (year > 57) {
                fullYear = 1800 + year;
            }
            else {
                fullYear = 2000 + year;
            }
            break;
        case 9:
            if (year > 36) {
                fullYear = 1900 + year;
            }
            else {
                fullYear = 2000 + year;
            }
            break;
    }
    return fullYear+"-"+ id.substring(2, 4) +"-"+ id.substring(0,2);
  };